import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrmExportValuePipe } from './crm-export-value.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [CrmExportValuePipe],
  exports: [CrmExportValuePipe]
})
export class CrmExportValuePipeModule {} 
